/* GLINT 12/09 — LE TRAIT SOUS LE TITRE CHOISI.
   Chaque groupe .glint-titres porte un span.glint-titres__trait ; il se place
   sous le bouton .is-current (position et largeur) et GLISSE d'un titre à
   l'autre quand on clique. Le choix lui-même (classe is-current, filtrage)
   reste au script du lieu (Studio, Builder, tiroir) : ici on ne fait que suivre.

   INTERDIT ICI, ET LA RAISON (payée le 12/09 par un site figé) : ne JAMAIS
   surveiller les classes du groupe avec un MutationObserver. La pose du trait
   ajoute ou retire elle-même une classe (is-pose) ; l'observateur se rappelait
   donc lui-même, et comme un rappel d'observateur est une micro-tâche, la file
   ne se vidait plus. Le navigateur ne rendait plus la main du tout : page qui
   charge à l'infini, plus rien de cliquable. On repose donc le trait sur des
   événements FRANCS (clic, image chargée, police prête, redimensionnement,
   quelques passes après l'arrivée) et jamais en réaction à ce qu'on écrit.

   Filet de sécurité : au-delà de 400 poses en une seconde, tout s'arrête. */
(function () {
  'use strict';
  if (window.glintTitres) return;
  window.glintTitres = true;

  var arrete = false;
  var compte = 0;
  var fenetre = 0;

  function poser(groupe, bouton, sec) {
    if (arrete || !groupe) return;
    /* Filet : si quelque chose nous rappelle en rafale, on coupe au lieu de
       figer la page. Mieux vaut un trait immobile qu'un site mort. */
    var t = Date.now();
    if (t - fenetre > 1000) { fenetre = t; compte = 0; }
    if (++compte > 400) { arrete = true; return; }

    var trait = groupe.querySelector('.glint-titres__trait');
    if (!trait) return;
    var cible = bouton || groupe.querySelector('.glint-titre.is-current');
    if (!cible) { trait.classList.remove('is-pose'); return; }
    var g = groupe.getBoundingClientRect(), r = cible.getBoundingClientRect();
    if (!g.width || !r.width) { trait.classList.remove('is-pose'); return; }
    if (sec) trait.style.transition = 'none';
    trait.style.width = r.width + 'px';
    trait.style.transform = 'translate3d(' + (r.left - g.left) + 'px,' + (r.bottom - g.top + 5) + 'px,0)';
    if (sec) { void trait.offsetWidth; trait.style.transition = ''; }
    trait.classList.add('is-pose');
  }

  function poserTous(sec) {
    var groupes = document.querySelectorAll('.glint-titres');
    for (var i = 0; i < groupes.length; i++) poser(groupes[i], null, sec);
  }

  function brancher(groupe) {
    if (groupe.getAttribute('data-glint-titres-ok')) return;
    groupe.setAttribute('data-glint-titres-ok', '1');
    poser(groupe, null, true);

    /* Les titres sont des images : leur largeur n'existe qu'une fois chargées. */
    var images = groupe.querySelectorAll('img');
    for (var i = 0; i < images.length; i++) {
      if (images[i].complete && images[i].naturalWidth) continue;
      var fini = function () { poser(groupe, null, true); };
      images[i].addEventListener('load', fini, { once: true });
      images[i].addEventListener('error', fini, { once: true });
    }

    /* Le groupe change de largeur (fenêtre, panneau qui s'ouvre) : on suit.
       Sans danger : le trait est en position absolue, il ne redimensionne
       jamais le groupe — d'où le `position: absolute` verrouillé dans la CSS. */
    if (typeof ResizeObserver === 'function') {
      new ResizeObserver(function () { poser(groupe, null, true); }).observe(groupe);
    }
  }

  function brancherTous(root) {
    var groupes = (root || document).querySelectorAll('.glint-titres');
    for (var i = 0; i < groupes.length; i++) brancher(groupes[i]);
  }

  /* Le clic : le lieu pose sa classe is-current de son côté, nous on suit le
     bouton cliqué tout de suite (une image de retard serait visible). */
  document.addEventListener('click', function (e) {
    if (arrete) return;
    var bouton = e.target && e.target.closest ? e.target.closest('.glint-titre') : null;
    if (!bouton) return;
    var groupe = bouton.closest('.glint-titres');
    if (!groupe) return;
    bouton.classList.remove('is-pop');
    void bouton.offsetWidth;
    bouton.classList.add('is-pop');
    window.requestAnimationFrame(function () { poser(groupe, bouton, false); });
  }, true);

  /* Porte de service pour le script d'un lieu qui change le titre courant
     sans clic (le Studio impose l'ambiance de son décor à l'arrivée). */
  window.glintTitresPoser = function () { poserTous(false); };

  function init() {
    brancherTous(document);

    /* Le tiroir est re-rendu par l'API des sections, le Studio montre son
       étape 03 après coup : on rebranche ce qui apparaît. childList seulement,
       et brancher() ne travaille qu'une fois par groupe. */
    if (typeof MutationObserver === 'function') {
      var minuterie = 0;
      new MutationObserver(function () {
        if (arrete) return;
        window.clearTimeout(minuterie);
        minuterie = window.setTimeout(function () { brancherTous(document); }, 150);
      }).observe(document.body, { childList: true, subtree: true });
    }

    /* Quelques passes franches : la police du mot ALL, les images, et le
       script du lieu qui choisit sa capsule de départ. */
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { poserTous(true); });
    window.setTimeout(function () { poserTous(true); }, 400);
    window.setTimeout(function () { poserTous(true); }, 1400);
    window.addEventListener('load', function () { poserTous(true); }, { once: true });
    window.addEventListener('resize', function () { poserTous(true); }, { passive: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
